import { render, staticRenderFns } from "./PublicBehavioralQnrIntroView.vue?vue&type=template&id=0acaa092&scoped=true&"
import script from "./PublicBehavioralQnrIntroView.vue?vue&type=script&lang=js&"
export * from "./PublicBehavioralQnrIntroView.vue?vue&type=script&lang=js&"
import style0 from "./PublicBehavioralQnrIntroView.vue?vue&type=style&index=0&id=0acaa092&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acaa092",
  null
  
)

export default component.exports